/**
 * Image Uploader with Preview Image
 * Image Cropping adding since version 1.1 (Requires cropper js CDN)
 * 
 * @author Michael Zenner <mzenner@perrill.com>
 * @version 1.1.0
 * @since 10-3-2022
 * 

 * 
 *** Html Usage:
 * 

 * data-required - if the image field is required
 * data-name - fills in the "name" on the input field for form handling
 * data-name - if set, this opens up the media library popup so you can choose an existing image
 * data-aspect-ratio - set this to lock the crop tool's aspect ratio (square/banner)
 * data-existing - fill in with path from database if image already exists
 * data-optional-crop - set this attribute if cropping is not mandatory

<div class="image-preview"
     data-required="true"
     data-name="media_id"
     data-use-media-library="true"
     data-use-avatar-library="true"
     data-aspect-ratio="square"
     data-existing="/path/to/image"
     data-optional-crop="true">
</div>

 * 
 */

 window.ImagePreview = new function()
 {
     this.init = function() {
        ImagePreview.buildHtml();

        jQuery('body').on('click', '.image-preview .add-image', function(event) {
            if(jQuery('body').hasClass('cropping')) {
                alert('Please save your crop first');
                return;
            }

            event.preventDefault();
            ImagePreview.addImageInput(this);
        });

        jQuery('body').on('change', '.image-preview input', function(event) {
            if(jQuery('body').hasClass('cropping')) {
                alert('Please save your crop first');
                return;
            }

            event.preventDefault();
            ImagePreview.buildPreview(this);
        });

        jQuery('body').on('click', '.image-preview .remove-image', function(event) {
            event.preventDefault();
            ImagePreview.removeImage(this);
        });

        jQuery('body').on('submit', 'form', function(event) {
            var scrollToRequired = false;

            if(jQuery('body').hasClass('cropping')) {
                event.preventDefault();
                alert('Please save your crop first');
                return false;
            }

            jQuery('.image-preview').each(function(index, el) {
                var required = jQuery(el).data('required');

                if(required) {
                   if(!jQuery(el).find('img.preview-image').length) {
                       event.preventDefault();

                       jQuery(el).find('.error').remove();
                       jQuery(el).append('<p class="error">Required Field*</p>');

                       scrollToRequired = true;
                       
                       return false;
                   } 
                }
            });

            if(scrollToRequired) {
                jQuery('html, body').animate({
                    scrollTop: jQuery('.image-preview .error').first().offset().top - 300
                }, 500);
            }
        });

        jQuery('body').on('click', '.media-library .choose-media-from-library', function(event) {
            event.preventDefault();
            ImagePreview.setImageFromMediaLibrary(this);
        });

        jQuery('body').on('click', '.media-library .choose-avatar-from-library', function(event) {
            event.preventDefault();
            ImagePreview.setImageFromAvatarLibrary(this);
        });

        jQuery('body').on('click', '.set-crop', function(event) {
            event.preventDefault();
            var el = jQuery(this).closest('.image-preview').find('input');
            jQuery(this).remove();
            ImagePreview.initializeCropper(el);
        });
     };

     /**
      * Build DOM for each image-preview present on the page
      */
     this.buildHtml = function() {
        jQuery('.image-preview:not(.initialized)').each(function(index, el) {
            jQuery(el).addClass('initialized');
            
            if(jQuery(el).data('existing')) {
                var html = '<a href="javascript:;" title="Replace Image" class="edit add-image">';
            } else {
                var html = '<a href="javascript:;" title="Add Image" class="add-image">';
            }
            
            if(jQuery(el).data('existing')) {
                var src = jQuery(el).data('existing');
                html += '<img class="preview-image" src="' + src + '" />';
            } else {
                html += '<span class="wrap text-center">';
                html += '<i class="fa-regular fa-cloud-arrow-up"></i>';
                html += '<span class="display-block text-center">Upload Image</span>';
                html += '</span>';
            }

            html += '</a>';

            if(jQuery(el).data('existing')) {
                html += '<a class="remove-image" href="javascript:;" title="Remove Image"><i class="fa fa-close"></i></a>';
            } else {
                html += '<a class="remove-image" href="javascript:;" title="Remove Image" style="display:none;"><i class="fa fa-close"></i></a>';
            }
            
            jQuery(el).html(html);
        });
     };

     /**
      * Adds empty image input to DOM
      *
      * @param obj el - image-preview anchor tag clicked
      */
     this.addImageInput = function(el) {
        var name         = jQuery(el).closest('.image-preview').data('name');
        var aspect_ratio = jQuery(el).closest('.image-preview').data('aspect-ratio');

        jQuery(el).closest('.image-preview').find('.error').remove();
        jQuery(el).closest('.image-preview').find('input').remove();
        jQuery('#' + name).remove();
        jQuery(el).closest('.image-preview').append("<input type='file' id='" + name + 
            "' style='display:none;' name='" + name + "[]' accept='.jpg,.jpeg,.png,.gif' />");

        if(jQuery(el).closest('.image-preview').data('use-media-library')) {
            jQuery(el).closest('.image-preview').append('<input type="hidden" name="' + name + '_media_library" />');
            jQuery(el).closest('.image-preview').append('<input type="hidden" name="' + name + '_avatar_library" />');

            if(jQuery(el).closest('.image-preview').data('use-avatar-library')) {
                Modals.loadAjaxModal('/users/media-library/get?name=' + name + '&avatar_library=true&aspect_ratio=' + aspect_ratio, '#media-library-modal');
            } else {
                Modals.loadAjaxModal('/users/media-library/get?name=' + name + '&aspect_ratio=' + aspect_ratio, '#media-library-modal');
            }
        } else {
            jQuery('#' + name).trigger('click');
        }
     };

     /**
      * Show preview of image uploaded
      *
      * @param obj el - file input uploaded to
      */
     this.buildPreview = function(el) {
        var file = $(el).get(0);

        if(el.files[0].size > 30000000) {
           alert("Max upload size is 30 megabytes");
           return false;
        };

        var type    = file.files[0].type;
        var preview = window.URL.createObjectURL(file.files[0]);
        
        jQuery(el).closest('.image-preview').find('.preview-image').remove();
        jQuery('.cropper-wrapper').remove();
        jQuery('.save-crop').remove();

        var optional_crop = false;
        if(jQuery(el).closest('.image-preview').data('optional-crop')) {
            optional_crop = true;
        }
        
        if(type != 'image/gif' && !optional_crop) {
            ImagePreview.initializeCropper(el);
        } else {
            jQuery(el).closest('.image-preview').find('.add-image').html('<img class="preview-image" src="' + preview + '" />');
            jQuery(el).closest('.image-preview').find('.remove-image').css('display', '');
            
            if(type != 'image/gif') {
                jQuery(el).closest('.image-preview').append('<button class="set-crop">Crop Image</button>');
            }
        }

        jQuery(el).closest('.image-preview').find('.add-image').addClass('edit');
     };

     /**
      * Initialize the cropper js library
      *
      * @param obj el - file input uploaded to
      */
     this.initializeCropper = function(el) {
        var file = $(el).get(0);

        var preview      = window.URL.createObjectURL(file.files[0]);
        var filename     = file.files[0].name;
        var type         = file.files[0].type;
        var aspect_ratio = jQuery(el).closest('.image-preview').data('aspect-ratio');

        var input_name     = jQuery(el).closest('.image-preview').data('name');
        var input_name_arr = input_name.split('_media_library_upload');
        input_name         = input_name_arr[0];

        jQuery('body').addClass('cropping');
        jQuery(el).closest('.image-preview').find('.add-image').hide();
        jQuery(el).closest('.image-preview').find('.remove-image').hide();
        jQuery(el).closest('.image-preview').append('<div class="cropper-wrapper"><img id="image-crop-preview" class="preview-image" src="' + preview + '" /></div>');
        jQuery(el).closest('.image-preview').append('<button class="save-crop">Save Crop</button>');
        jQuery(el).closest('.image-preview').find('.add-image').empty();
        
        const image = document.getElementById('image-crop-preview');
        
        if(aspect_ratio == 'square') {
            var cropper = new Cropper(image, {
              aspectRatio: 1 / 1,
              zoomable: false,
              zoomOnTouch: false,
              zoomOnWheel: false
            });
        } else if(aspect_ratio == 'banner') {
            var cropper = new Cropper(image, {
              aspectRatio: 3 / 1,
              zoomable: false,
              zoomOnTouch: false,
              zoomOnWheel: false
            });
        } else if(aspect_ratio == 'banner_tall') {
            var cropper = new Cropper(image, {
              aspectRatio: 1640 / 600,
              zoomable: false,
              zoomOnTouch: false,
              zoomOnWheel: false
            });
        } else if(aspect_ratio == 'wallpaper') {
            var cropper = new Cropper(image, {
              aspectRatio: 1920 / 1080,
              zoomable: false,
              zoomOnTouch: false,
              zoomOnWheel: false
            });
        } else {
            var cropper = new Cropper(image, {
              zoomable: false,
              zoomOnTouch: false,
              zoomOnWheel: false
            });
        }

        jQuery('body').on('click', '.save-crop', function(event) {
            event.preventDefault();
            
            cropper.getCroppedCanvas().toBlob((blob) => {
              jQuery('.cropper-wrapper').remove();
              var url_creator = window.URL || window.webkitURL;
              var image_url   = url_creator.createObjectURL(blob);
              jQuery(el).closest('.image-preview').find('.add-image').css('display', '');
              jQuery(el).closest('.image-preview').find('.add-image').html('<img class="preview-image" src="' + image_url + '" />');
              jQuery('.save-crop').remove();
              jQuery(el).closest('.image-preview').find('.remove-image').css('display', '');
              jQuery('body').removeClass('cropping');

              const fileInput = document.querySelector('#' + input_name);
              const myFile    = new File([blob], filename, {
                  type,
                  lastModified: new Date(),
              });

              const dataTransfer = new DataTransfer();
              dataTransfer.items.add(myFile);
              fileInput.files = dataTransfer.files;
            });
        });
     };

     /**
      * Removes uploaded image
      *
      * @param obj el - remove button clicked
      */
     this.removeImage = function(el) {
        jQuery(el).closest('.image-preview').find('input').remove();
        jQuery(el).closest('.image-preview').find('.add-image').empty();
        jQuery(el).closest('.image-preview').find('.add-image').removeClass('edit');
        jQuery(el).css('display', 'none');

        var name = jQuery(el).closest('.image-preview').data('name');
        jQuery(el).closest('.image-preview').append('<input type="hidden" name="remove_' + name + '" value="1">');

        var html = '<span class="wrap text-center">';
        html += '<i class="fa-regular fa-cloud-arrow-up"></i>';
        html += '<span class="display-block text-center">Upload Image</span>';
        html += '</span>';
        jQuery(el).closest('.image-preview').find('.add-image').html(html);
     };

     /**
      * Sets preview image via an image from the media library
      *
      * @param obj el - media clicked
      */
     this.setImageFromMediaLibrary = function(el) {
        var input_name = jQuery(el).data('name');
        var image_id   = jQuery(el).data('id');
        var src        = jQuery(el).data('src');

        jQuery('#media-library-modal').modal('hide');

        var image_preview = jQuery('input[name="'+input_name+'_media_library"]').closest('.image-preview');

        jQuery('input[name="'+input_name+'_media_library"]').val(image_id);
        jQuery(image_preview).find('.add-image').html('<img class="preview-image" src="' + src + '" />');
        jQuery(image_preview).find('.remove-image').css('display', '');
        jQuery(image_preview).find('.add-image').addClass('edit');
     };

     /**
      * Sets preview image via an image from the avatar library
      *
      * @param obj el - media clicked
      */
     this.setImageFromAvatarLibrary = function(el) {
        var input_name = jQuery(el).data('name');
        var image_id   = jQuery(el).data('id');
        var src        = jQuery(el).data('src');

        jQuery('#media-library-modal').modal('hide');

        var image_preview = jQuery('input[name="'+input_name+'_avatar_library"]').closest('.image-preview');

        jQuery('input[name="'+input_name+'_avatar_library"]').val(image_id);
        jQuery(image_preview).find('.add-image').html('<img class="preview-image" src="' + src + '" />');
        jQuery(image_preview).find('.remove-image').css('display', '');
        jQuery(image_preview).find('.add-image').addClass('edit');
     };
 }

jQuery(document).ready(function($) { 
     ImagePreview.init();
});
